import { Link } from 'gatsby';
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import SectionWrapper, { Container } from './whyRestoration.style';
import Fade from 'react-reveal/Fade';

  import { SectionHeader } from '../global.style';
  import Heading from 'common/components/Heading';


const WhyRestoration = () => {

	  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // const apiUrl = process.env.GATSBY_API_URL;
  // const baseUrl = process.env.GATSBY_BASE_URL;

  useEffect(() => {
    // Fetch data from the API
    const fetchData = async () => {
      try {
        const response = await axios.get(`https://radianceadmin.manageprojects.in/api/homeour-services`);
        if (response.data.success) {
          setServices(response.data.data);
        } else {
          setError('Failed to fetch data');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);


  
	useEffect(() => {
		import("bootstrap/dist/js/bootstrap.bundle.min.js").then(() => {
		  // Bootstrap JavaScript is loaded and can be used here
		  // Initialize Bootstrap components or perform other necessary operations
		});
	  }, []);


  if (loading) {
    return <div></div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }
  
  return (
    <SectionWrapper id="whyRestoration">
		<Fade bottom>
		<Container class="myContainer">
		<Fade left>
        <SectionHeader className='' style={{textAlign: 'left', paddingBottom: '25px'}}>
          <Heading as="h5" content="Our Services" />
          <Heading content="Hair Wig For Men And Women in Delhi" />
        </SectionHeader>
		</Fade>
		</Container>
      </Fade>
	  <Fade bottom>
      <Container class="myContainer">
        <div className='row'>
      		<div className="col-md-3 mb-35">
					<div className="services__area-button">

					<ul className="nav nav-pills mypx-3">
                {services.map((service, index) => (
                  <li key={service.id} className="nav-item ">
                    <button
                      className={`nav-item-button ${index === 0 ? 'active' : ''}`}
                      data-bs-toggle="pill"
                      data-bs-target={`#service-${service.id}`}
                    >
                      <img
                        className="nav-item-button-icon"
                        src={`https://radianceadmin.manageprojects.in/storage/${service.icon}`}
                        alt={service.service_title}
                      />
					                    
                     {service.service_title} 
                    </button>
                  </li>
                ))}
              </ul>
      				
            </div>
				</div>

            <div className="col-md-9">					
					<div className="tab-content">
					{services.map((service, index) => (
                <div
                  key={service.id}
                  className={`tab-pane fade ${index === 0 ? 'active show' : ''}`}
                  id={`service-${service.id}`}
                >
							<div className="row align-items-center">
								<div className="col-md-12 px-4">
									<div className="services__area-image mb-4">
									<img
                          className="img__full"
                          src={`https://radianceadmin.manageprojects.in/storage/${service.image}`}
                          alt={service.service_title}
                        />
									</div>									
								</div>
								<div className="col-md-12 px-4">
									<div className="services__area-right ml-40 lg-ml-0">
										<div className="services__area-right-title">
											<h3>{service.section_heading} </h3>
											<p
                          className="services__area-right-title"
                          dangerouslySetInnerHTML={{ __html: service.pcontent }}
                        ></p>
											<Link to={service.page_url}className="btn btn-default black" style={{ marginLeft: 'auto' }}>
                  Know More
                </Link>
										</div>
									</div>
								</div>
							</div>
						</div>
))}
					</div>
				</div>
        </div>
      </Container>
	  </Fade>
    </SectionWrapper>
  );
};

export default WhyRestoration;
